export enum AnalysisPanelTabs {
    ThoughtProcessTab = "thoughtProcess"
}
